if ($(".box-list--box").length > 0) {
  $(".box-list--box").on("click", function () {
    $(".box-list--box")
      .not(this)
      .removeClass("is-showing")
      .attr("aria-expanded", "false");
    $(this).toggleClass("is-showing");
    if ($(this).hasClass("is-showing")) {
      $(this).attr("aria-expanded", "true");
    } else {
      $(this).attr("aria-expanded", "false");
    }
  });
}
